import React from 'react';
import Lazyload from 'react-lazyload';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { MediaCacheShape } from 'utils/shapes';
import ArenaIconBar from 'components/arena/ArenaIconBar';
import ArenaItemPreview from 'components/arena/ArenaItemPreview';
import { gettext } from 'utils/text';

const ArenaMediaItem = ({ item, actionCallbackFactory, actionClassNames, dispatch }) => {
    const { actionCallback, actionLabel } = actionCallbackFactory ? actionCallbackFactory(item, { dispatch }) : {};
    return (
        <div className="arena__item">
            <a href={item.link}>
                <Lazyload height={item.content_preview.height} once>
                    {item.is_talent && <div className="arena__item__label">{gettext('Trafotalent')}</div>}
                    <ArenaItemPreview title={item.title} type={item.type} itemContent={item.content_preview} />
                </Lazyload>
            </a>
            <div className="arena__item__meta">
                <a href={item.link}>
                    <h4 className="arena__item__title mb-0">{item.title}</h4>
                    <time className="arena__item__time">{item.created_at}</time>
                </a>
                <div className="arena__item__bottom">
                    <div className="arena__item__bottom__left">
                        <a href={item.user.link}>
                            <div className="arena__item__author">
                                <img className="arena__item__author__image" alt="" src={item.user.avatar_url} />
                                <span>{item.user.name}</span>
                            </div>
                        </a>
                    </div>
                    {actionCallbackFactory && actionLabel ? (
                        <button onClick={actionCallback} className={actionClassNames}>
                            {actionLabel}
                        </button>
                    ) : (
                        <ArenaIconBar item={item} commentsLink={`${item.link}#comments`} />
                    )}
                </div>
            </div>
        </div>
    );
};

ArenaMediaItem.propTypes = {
    item: MediaCacheShape.isRequired,
    actionCallbackFactory: PropTypes.func,
    actionClassNames: PropTypes.string,
};

ArenaMediaItem.defaultProps = {
    actionCallbackFactory: null,
    actionClassNames: 'btn btn-primary btn-xs mb-2',
};

const mapDispatchToProps = (dispatch) => ({
    dispatch,
});

export default connect(null, mapDispatchToProps)(ArenaMediaItem);



// WEBPACK FOOTER //
// ./src/components/arena/ArenaMediaItem.js